import { render, staticRenderFns } from "./TarifsResa.vue?vue&type=template&id=ae09f07a&scoped=true&"
import script from "./TarifsResa.vue?vue&type=script&lang=js&"
export * from "./TarifsResa.vue?vue&type=script&lang=js&"
import style0 from "./TarifsResa.vue?vue&type=style&index=0&id=ae09f07a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae09f07a",
  null
  
)

export default component.exports